import { z } from "zod";
import { EDeliveryType, ENhrStatus } from "@zeal/common/dist/uhura";

const nhrStatusEnumValues = Object.values(ENhrStatus) as [string, ...string[]];

export const newHireRecordSchema = z.object({
  type: z.enum(Object.values(EDeliveryType) as [string, ...string[]]),
  status: z.string(),
  sent_date: z.string(),
  record_id: z.string(),
  s3_key: z.string(),
});

export type INewHireRecord = z.infer<typeof newHireRecordSchema>;

export const newHireWorkerSchema = z.object({
  worker_id: z.string(),
  worker_type: z.enum(["employee", "contractor"]),
  first_name: z.string(),
  last_name: z.string(),
  company_id: z.string(),
  company_name: z.string(),
  state: z.string(),
  nhr_record: newHireRecordSchema.optional(),
});

export type INewHireWorker = z.infer<typeof newHireWorkerSchema>;

export const getNewHireWorkersRequestSchema = z
  .object({
    sent_date: z.string(),
    state: z.string(),
    status: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.status?.trim()) {
      return;
    }
    const tokens = data.status
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    for (const token of tokens) {
      if (!nhrStatusEnumValues.includes(token)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Invalid NHR status: ${token}`,
          path: ["status"],
        });
      }
    }
  });

export type TGetNewHireWorkersRequest = z.infer<
  typeof getNewHireWorkersRequestSchema
>;

export const getNewHireWorkersResponseSchema = z.object({
  data: z.array(newHireWorkerSchema),
});

export type TGetNewHireWorkersResponse = z.infer<
  typeof getNewHireWorkersResponseSchema
>;
